<template>
    <div id="classask"
         class="error-task">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back"><i class="icon-fanhui"></i></span>
                第{{qnumber}}题
            </div>
        </div>
        <div v-if="loading">
            <div class="nodata"
                 v-if="false">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <div class="wrap"
                 v-else>
                <div class="question">
                    <p class="title"
                       v-if="question.subject"><span v-html="question.subject"></span>(<span class="answer">{{question.answer}}</span>)
                    </p>
                </div>
            </div>
            <div v-if="wrong_names">
                <div class="content"
                     v-if="wrong_names.length">
                    <div class="title">答错<span>{{wrong_names.length}}</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names">{{name}}</span>
                    </div>
                </div>
                <div class="content"
                     v-else>
                    <div class="title">答错<span>0</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names"></span>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/tealoading.vue';

export default {
    data () {
        return {
            sid: this.$route.params.sid,
            classid: this.$route.params.classid,
            taskid: this.$route.params.taskid,
            qid: this.$route.query.qid,
            askid: this.$route.query.askid,
            qnumber: this.$route.params.qnumber.slice(0, 1),
            number: this.$route.params.qnumber.slice(1),
            testType: this.$route.query.testType,
            wrong_names: [],
            question: {},
            loading: false
        }
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
    },
    created () {
        this.$http.post(API_URL_TASK_API + "/maths/check/quick/question", {
            "message_id": this.taskid,
            "unit_class_id": this.classid,
            "qid": this.qid
        }).then(res => {
            res = res.data;
            this.loading = true;
            if (res.response == "ok") {
                this.wrong_names = res.data.wrong_stu
                this.question = res.data.question;
            }
        });
    },
    destroyed () {
    },
    components: {
        loadingS,
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.error-task {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 79px / $ppr;
            height: 96px / $ppr;
            background: url(../img/choose_back.png) no-repeat center;
            background-size: 0.45rem 0.85rem;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}

.content {
    background-color: $c-fbg;
    .title {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 36px / $ppr;
        padding: 0 $w;
        border-bottom: 1px / $ppr solid #e8e8e8;
        font-weight: 600;
        span {
            //color: $c-danger;
        }
    }
    .name {
        padding: $w $w;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        min-height: 200px / $ppr;
        span {
            width: 25%;
            font-size: 30px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
        }
    }
}

.nodata {
    color: $c-light;
    margin-top: 50px / $ppr;
    margin-bottom: 50px / $ppr;
    text-align: center;
    span {
        display: inline-block;
        color: $c-litgray;
        font-size: 110px / $ppr;
        margin-bottom: 36px / $ppr;
    }
}

.question {
    margin-bottom: 24px / $ppr;
    .title {
        font-size: 30px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        background-color: $c-fbg;
        padding: 0 $w;
    }
    .answer {
        color: #66cc22;
        font-size: 30px / $ppr;
    }
    .checked {
        color: #66cc22 !important;
        .spot {
            background-color: #66cc22 !important;
            border: 1px / $ppr solid #66cc22 !important;
            color: #fff;
        }
    }
}

.question .option:last-child {
    border: 0 !important;
}
</style>
